"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of Object.fromEntries() until we run a recent enough version
 * of NodeJS.
 *
 * @hidden
 */
function fromEntries(iterable) {
    return iterable.reduce(function (obj, _a) {
        var key = _a[0], value = _a[1];
        obj[key] = value;
        return obj;
    }, {});
}
/**
 * Recursively strips null from source parameter.
 *
 * - Literals string, numbers etc will be returned as-is.
 * - Literal `null` will return `undefined`
 * - Arrays with `null` be replace element with `undefined`, i.e. the length of
 *   the array is not modified.
 * - Object values with `null` will be removed, i.e. `hasOwnProperty(..)` will
 *   return `false`.
 *
 * @param src - Source value
 * @returns A copy of the source parameter with any null stripped
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
function stripNull(src) {
    /* handle literal null */
    if (src === null) {
        return undefined;
    }
    /* handle arrays recursively */
    if (Array.isArray(src)) {
        return src.map(stripNull);
    }
    /* handle pod literals such as string, number, etc */
    if (typeof src !== 'object') {
        return src;
    }
    /* unpack object to a [key, value] array */
    var entries = Object.entries(src)
        /* filter out any entries where value is null */
        .filter(function (_a) {
        var value = _a[1];
        return value !== null;
    })
        /* recursively replace values from the [key, value] array */
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, stripNull(value)];
    });
    /* reconstruct a new object from the [key, value] array */
    return fromEntries(entries);
}
exports.stripNull = stripNull;
/* eslint-enable @typescript-eslint/no-explicit-any */
//# sourceMappingURL=StripNull.js.map